const CLIENT_ROUTES = [
  "/projects",
  "/test-cases",
  "/test-runs",
  "/test-plans",
  "/defects",
  "/reports",
  "/settings",
  "/client-configuration",
  "/settings/customization",
  "/customization",
  "/templates",
  "/fields",
  "/project-settings",
  "/data-management",
  "/suites",
  "/baselines",
  "/branches",
  "/shared-steps",
];

const GLOBAL_ROUTES = ["/clients", "/users", "/auth", "/login", "/signup"];

export const isClientContext = () => {
  if (typeof window === "undefined") return false;

  const path = window.location?.pathname || "";

  if (GLOBAL_ROUTES.some((route) => path.includes(route))) {
    return false;
  }

  return CLIENT_ROUTES.some((route) => path.includes(route));
};

export const getClientId = () => {
  if (typeof window === "undefined") return null;

  if (window.__CLIENT_ID__) return window.__CLIENT_ID__;

  const params = new URLSearchParams(window.location.search);
  if (params.get("client_id")) return params.get("client_id");

  return localStorage.getItem("client_id");
};

export const injectClientIdIntoConfig = (config = {}) => {
  if (!isClientContext()) return config;

  const clientId = getClientId();
  if (!clientId) return config;

  if (!config.params) config.params = {};
  if (!config.params.client_id) {
    config.params.client_id = clientId;
  }

  const method = (config.method || "").toLowerCase();
  const supportsBody = ["post", "put", "patch", "delete"].includes(method);
  const isPlainObject =
    config.data &&
    typeof config.data === "object" &&
    !(config.data instanceof FormData) &&
    !Array.isArray(config.data);

  if (supportsBody && isPlainObject && !config.data.client_id) {
    config.data.client_id = clientId;
  }

  return config;
};
